import { LicenseManager as LicenseManagerGrid, ModuleRegistry, ValidationModule } from 'ag-grid-enterprise';
import { LicenseManager as LicenseManagerCharts } from 'ag-charts-enterprise';

import { getRuntimeConfig } from '@/lib/runtimeConfig';

function agGridLicenseInitializer() {
  const licenseKey = getRuntimeConfig().env.REACT_APP_AG_GRID_LICENSE;
  ModuleRegistry.registerModules([ValidationModule]);
  LicenseManagerGrid.setLicenseKey(licenseKey);
  LicenseManagerCharts.setLicenseKey(licenseKey);
}

export default agGridLicenseInitializer;
